<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,0C15,0,1,0,1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1,16,15,16,15,16C15.55,16,16,15.55,16,15C16,15,16,1,16,1C16,0.45,15.55,0,15,0C15,0,15,0,15,0ZM14,14C14,14,13.85,14,13.85,14C13.82,13.91,13.81,13.84,13.77,13.75C13.43,12.96,11.76,12.44,10.65,11.95C9.54,11.46,9.69,11.16,9.65,10.75C9.64,10.69,9.64,10.63,9.64,10.57C10.02,10.23,10.33,9.77,10.53,9.24C10.53,9.24,10.54,9.21,10.54,9.2C10.58,9.08,10.62,8.96,10.65,8.84C10.9,8.79,11.05,8.51,11.11,8.25C11.17,8.15,11.29,7.89,11.26,7.6C11.22,7.23,11.07,7.05,10.91,6.98C10.91,6.96,10.91,6.94,10.91,6.92C10.91,6.44,10.87,5.76,10.78,5.31C10.76,5.19,10.73,5.06,10.7,4.94C10.54,4.39,10.19,3.89,9.74,3.55C9.26,3.19,8.6,3,8,3C7.41,3,6.74,3.19,6.27,3.55C5.82,3.9,5.47,4.39,5.31,4.94C5.27,5.07,5.25,5.19,5.23,5.32C5.14,5.77,5.1,6.45,5.1,6.93C5.1,6.95,5.1,6.97,5.1,6.99C4.92,7.05,4.77,7.23,4.73,7.61C4.7,7.9,4.82,8.15,4.88,8.26C4.94,8.52,5.09,8.8,5.35,8.85C5.38,8.97,5.42,9.1,5.46,9.21C5.46,9.22,5.47,9.23,5.47,9.23C5.47,9.23,5.47,9.24,5.47,9.24C5.68,9.78,6,10.25,6.39,10.59C6.39,10.64,6.38,10.7,6.38,10.75C6.34,11.16,6.46,11.45,5.35,11.95C4.24,12.44,2.58,12.96,2.23,13.75C2.19,13.84,2.18,13.91,2.15,14C2.15,14,2,14,2,14C2,14,2,2,2,2C2,2,14,2,14,2C14,2,14,14,14,14C14,14,14,14,14,14Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Mugshot',
} as DefineComponent
</script>
